import React from 'react';
import { RecipePage } from './recipe.constants';

export default function Recipe(props) {
    return (
        <>
        
            <RecipePage id={props.match.params.id}/>
        </>
    )
}
